module.exports = __webpack_public_path__ + "static/media/home-veridomi.7bfa446f.jpg";